// extracted by mini-css-extract-plugin
export default {"hi":"Hi_hi__mkG-+","description":"Hi_description__JGRk3","btn":"Hi_btn__nn+Ax"};